import { render } from "./Favorite.vue?vue&type=template&id=c79c9230&ts=true"
import script from "./Favorite.vue?vue&type=script&lang=ts"
export * from "./Favorite.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\SCMQ\\project\\HTML\\mq-player-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__